import { Facebook, Globe, Instagram, Linkedin, Mail, Youtube } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

function resolveSocialIconComponent(label: string, href?: string): LucideIcon {
  const normalized = `${label} ${href ?? ''}`.toLowerCase();

  if (normalized.includes('instagram')) return Instagram;
  if (normalized.includes('facebook')) return Facebook;
  if (normalized.includes('youtube')) return Youtube;
  if (normalized.includes('linkedin')) return Linkedin;
  if (normalized.includes('mail') || normalized.includes('email') || normalized.includes('mailto:')) return Mail;
  return Globe;
}

export function renderSocialIconByLabel(label: string, href?: string, className = 'h-[1em] w-[1em]') {
  const Icon = resolveSocialIconComponent(label, href);
  return <Icon className={className} />;
}
